module.exports = __webpack_public_path__ + "assets/ef84e23f8212c0c4c327e877689f1683.mp3";